module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Backward-f14ce782e491014dd95a973059da6489.svg";